import React, {useRef, useState, useEffect } from 'react';
import './acc-shipping.scss';
import Form, {
    EmptyItem,
    Item,
    Label,
    ButtonItem,
    ButtonOptions,
    RequiredRule
} from 'devextreme-react/form';
import serviceType from '../../../utils/service-type';
import weightMetrics from '../../../utils/weight-metrics';
import sizeMetrics from '../../../utils/package-size';
import package_ from '../../../utils/package';
import contentType from '../../../utils/custome-intl';
import DataSource from 'devextreme/data/data_source';
import LoadIndicator from 'devextreme-react/load-indicator';
import 'font-awesome/css/font-awesome.min.css';
import sessions from '../../../sessions';
import paymentApi from '../../../api/payment';
import addressApi from '../../../api/address';
import shipmentApi from '../../../api/shipment';
import orderApi from '../../../api/order';
import ViewSDKClient from '../../../components/adobe-dc/ViewSDKClient';
import { confirm } from 'devextreme/ui/dialog';

const AccShipping = ({data}) => {
    //console.log("result",data);
    const userId = sessions.getSession("user")?.id;
    const role = sessions.getSession("user")?.roles[0];
    const auth = sessions.getSession("user")?.accessToken;
    const [shipmentData, setShipmentData] = useState();
    const [addressData, setAddressData] = useState();
    const [weightUnit, setWeightUnit] = useState();
    const [sizeUnit, setSizeUnit] = useState();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [now,setNow] = useState();

    useEffect(()=>{
        setNow(new Date());
        setSizeUnit('in');
        setWeightUnit('lb');
        (async()=>{
            setShipmentData({
                "orderId":data?.orderId,
                "name": data?.name,
                "serviceType":data?.serviceType,
                "shipFromId":data?.shipFrom,
                "shipDate":data?.shipDate,
                "package":data?.package,
                "weight_units":data?.weight_units?data?.weight_units:'lb',
                "weight_value":data?.weight_value,
                "size_units":data?.size_units?data?.size_units:'in',
                "size_length":data?.size_length,
                "size_width":data?.size_width,
                "size_height":data?.size_height,
                "contentType":data?.contentType,
                "cost":data?.cost,
                "warehouseReceiveTimes": data?.warehouseReceiveTimes,
                "notes": data?.notes
            })
            await addressApi.getAddressByUserId(userId,auth).then(result=>{
                setAddressData(result.data.data)
            }).catch(err=>{
                console.log(err);
            })
        })()
    },[data]);

    const serviceTypeDataSource = new DataSource({
        store: {
            data: serviceType,
            type: 'array',
            key: 'ID'
        }
    });

    const WeightDataSource = new DataSource({
        store: {
            data: weightMetrics,
            type: 'array',
            key: 'ID'
        },
    });

    const SizeDataSource = new DataSource({
        store: {
            data: sizeMetrics,
            type: 'array',
            key: 'ID'
        },
    });

    const PackageDataSource = new DataSource({
        store: {
            data: package_,
            type: 'array',
            key: 'ID'
        },
    });

    const contentTypeDataSource = new DataSource({
        store: {
            data: contentType,
            type: 'array',
            key: 'id'
        }
    });

    const shipsFromDataSource = new DataSource({
        store: {
            data: addressData,
            type: 'array',
            key: '_id'
        }
    });

    const sizeUnitOnChange = ({value}) =>{
        setSizeUnit(value)
    }

    const weightUnitOnChange = ({value}) =>{
        setWeightUnit(value)
    }

    const disabledPrintButton = () =>{
        if(role==='ROLE_ADMIN'){
            if(data?.serviceType === 'Standard Shipment')
                return false;
        }else{
            if(data?.status === 'awaiting-shipment')
                return false;
            else
                return true;
        }
    }

    const PreviewLabel = async(e) => {
        if(e)e.preventDefault();
        setMessage("");

        try{
            const payload = shipmentData;
            const {serviceType,cost,notes} = shipmentData;
            const paymentPayload = {
                "cost":cost,
                "notes": notes
            }
            if(role==='ROLE_ADMIN'){
                if(serviceType==='Standard Shipment'){
                    setLoading(true);
                   if(data?.batchNo){
                        setMessage('Please print from the multiple label button');
                        setLoading(false);
                   }else{
                    await paymentApi.addCredit(data?.userId,paymentPayload,auth).then(async()=>{
                        await shipmentApi.updateShipmentByAdmin([shipmentData],auth);
                        var pdfName = `label-${data?.shipmentNo}`;
                        await shipmentApi.fetchLabel(pdfName).then(res => {
                            //console.log(res.data);
                            const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                            var url = window.URL.createObjectURL(pdfBlob);
                            setLoading(false);
                            const viewSDKClient = new ViewSDKClient();
                            viewSDKClient.ready().then(() => {
                            viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                            });
                        });
                    }).catch(err=>{
                        setLoading(false);
                    })
                   }
                }else{
                    if(data?.batchNo){
                        setMessage('Please print from the multiple label button');
                        setLoading(false);
                   }else{
                        if(data?.labelPrinted){
                            let result = confirm("Are you sure want to print the label again?", "Confirm changes");
                            result.then(async(dialogResult) => {
                                if(dialogResult){
                                    setLoading(true);
                                    await paymentApi.addCredit(data?.userId,paymentPayload,auth).then().catch(err=>{
                                        console.log(err);
                                        setLoading(false);
                                    });
                                    await shipmentApi.generateLabel(data?.userId,payload,auth).then(async(result)=>{
                                    var pdfName = result.data.data;
                                    await shipmentApi.fetchLabel(pdfName).then(res => {
                                        //console.log(res.data);
                                        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                                        var url = window.URL.createObjectURL(pdfBlob);
                                        setLoading(false);
                                        const viewSDKClient = new ViewSDKClient();
                                        viewSDKClient.ready().then(() => {
                                        viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                        });
                                    });
                                    }).catch(err=>{
                                        console.log(err);
                                        setLoading(false);
                                    })
                                }
                            });
                        }else{
                            setLoading(true);
                            await paymentApi.addCredit(data?.userId,paymentPayload,auth).then().catch(err=>{
                                console.log(err);
                                setLoading(false);
                            });
                             await shipmentApi.generateLabel(data?.userId,payload,auth).then(async(result)=>{
                            var pdfName = result.data.data;
                            await shipmentApi.fetchLabel(pdfName).then(res => {
                                //console.log(res.data);
                                const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                                var url = window.URL.createObjectURL(pdfBlob);
                                setLoading(false);
                                const viewSDKClient = new ViewSDKClient();
                                viewSDKClient.ready().then(() => {
                                viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                });
                            });
                            }).catch(err=>{
                                console.log(err);
                                setLoading(false);
                            })
                    }   
                    
                   }
                }
            }else{
                await paymentApi.getUserLatestBalance(userId,auth).then(async(result)=>{
                    setLoading(true);
                    const balance =  result.data.data.balance;
                    if(balance > 50){
                        if(serviceType==='Standard Shipment'){
                            await shipmentApi.generateLabelAndPackingSlips(userId,payload,auth).then(async(result)=>{
                                var pdfName = result.data.data;
                                await orderApi.fetchPackingSlips(pdfName).then(res => {
                                    const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                                    var url = window.URL.createObjectURL(pdfBlob);
                                    setLoading(false);
                                    const viewSDKClient = new ViewSDKClient();
                                    viewSDKClient.ready().then(() => {
                                    viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                    });
                                });
                            }).catch(err=>{
                                if(err.message.includes("401")){
                                    setMessage("Only support USD!");
                                }else if(err.message.includes("403")){
                                    setMessage("Could not found service for the destination country");
                                }
                                else{
                                    setMessage("Error");
                                }
                                setLoading(false);
                            })
                        }
                        else{
                            const packingPayload={
                                data:data,
                                shipmentData:shipmentData
                            }
                            await orderApi.generatePackingSlips(userId,packingPayload,auth).then(async(result)=>{
                                var pdfName = result.data.data;
                                 await orderApi.fetchPackingSlips(pdfName).then(res => {
                                    const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
                                    var url = window.URL.createObjectURL(pdfBlob);
                                    setLoading(false);
                                    const viewSDKClient = new ViewSDKClient();
                                    viewSDKClient.ready().then(() => {
                                        viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,pdfName);
                                 })
                            });
                            });
                        }
                    }else{
                        setLoading(false);
                        setMessage("Your balance is not enough to print the label");
                    }
                }).catch(err=>{
                    setLoading(false);
                });
            }
            
        }catch(e){
            setLoading(false);
        }
    }

    return (
        <React.Fragment>
            <div className={'form-shipping'}>
                <div className={'title'}>Shipment Information</div>
                <form id={'shipment-form'} onSubmit={PreviewLabel}>
                <Form formData={shipmentData} colCount={5} labelLocation="left" alignItemLabels={true}>
                    <Item
                        dataField={'orderId'}
                        colSpan={5}
                        visible={false}
                        editorOptions={{
                            value:data?._id,
                            visible: false
                        }}>
                    </Item>
                    <Item
                        dataField={'name'}
                        colSpan={5}
                        editorOptions={{
                            readOnly: true,
                        }}>
                        <Label text="Requested"/>
                    </Item>
                    <Item 
                        id={'ship-from'}
                        editorType={'dxSelectBox'}
                        isRequired={true}
                        dataField="shipFromId"
                        colSpan={5}
                        disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                        editorOptions={{
                        dataSource: shipsFromDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: '_id',
                        height: 40,
                        placeholder: 'Select ship from'
                    }}>
                        <RequiredRule message="ship from is required"/>
                        <Label text={'Ship From'}/>
                    </Item>
                    <Item
                        editorType={'dxDateBox'}
                        dataField="shipDate"
                        colSpan={5}
                        disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                        editorOptions={{
                            useMaskBehavior: true,
                            type: "date",
                            displayFormat: "shortdate",
                            min:now,
                            height: '40px',
                            placeholder: 'Select Shipping Date',
                    }}>
                        <Label text={'Shipment Date'}/>
                        <RequiredRule message="shipping date is required"/>
                    </Item>
                    <Item
                        colSpan={5}
                        editorType={'dxSelectBox'}
                        dataField="serviceType"
                        disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                        editorOptions={{
                        dataSource: serviceTypeDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        placeholder: 'Select service type'
                    }}>
                        <RequiredRule message="service type is required"/>
                    </Item>
                    <Item
                        colSpan={5}
                        disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                        editorType={'dxSelectBox'}
                        dataField="package"
                        editorOptions={{
                        dataSource: PackageDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        placeholder: 'Select package',
                    }}>
                         <RequiredRule message="package is required"/>
                    </Item>
                    <Item 
                        id={'content-type'}
                        editorType={'dxSelectBox'}
                        isRequired={true}
                        dataField="contentType"
                        colSpan={5}
                        visible= {data?.country !== 'US'? true :false}
                        disabled={(data?.batchNo)?true:false}
                        editorOptions={{
                        dataSource: contentTypeDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        height: 40,
                        placeholder: 'Select content type'
                    }}>
                        <RequiredRule message="content type is required"/>
                        <Label text={'content Type'}/>
                    </Item>
                    <Item
                        editorType={'dxSelectBox'}
                        dataField="weight_units"
                        disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                        editorOptions={{
                        dataSource: WeightDataSource,
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        height: '25px',
                        width: '50px',
                        marginRight: '4rem',
                        value: weightUnit,
                        onValueChanged:weightUnitOnChange,
                        placeholder: ' '
                    }}>
                         <RequiredRule message="weight metrics is required"/>
                         <Label text={'weight'}/>
                    </Item>
                    <EmptyItem cssClass={'acc-empty-class'}/>
                    <Item 
                    editorType={'dxNumberBox'} 
                    colSpan={3}
                    dataField={'weight_value'}
                    disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true} 
                    editorOptions={{
                        placeholder:'W',
                        stylingMode: 'outlined',
                        height: '30px',
                        width: '55px',
                        margin: 15,
                        invalidValueMessage:"Value must be a number",
                        min:0
                    }}>
                        <RequiredRule message=" weight value is required"/>
                        <Label text=" "/>
                    </Item>
                     <Item
                        editorType={'dxSelectBox'}
                        dataField="size_units"
                        disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                        editorOptions={{
                        dataSource: SizeDataSource,
                        width: '50px',
                        height: '30px',
                        margin: '2rem',
                        searchEnabled: true,
                        displayExpr: 'name',
                        valueExpr: 'name',
                        placeholder: 'Select size units',
                        value:sizeUnit,
                        onValueChanged: sizeUnitOnChange
                    }}>
                         <RequiredRule message="size units is required"/>
                    </Item>
                    <EmptyItem cssClass={'acc-empty-class'}/>
                    <Item 
                    editorType={'dxNumberBox'} 
                    dataField={'size_length'} f
                    disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                    editorOptions={{
                        placeholder:'L',
                        stylingMode: 'outlined',
                        height: '30px',
                        width: '50px'
                    }}>
                        <RequiredRule message="length is required"/>
                        <Label text="L" location={'right'}/>
                    </Item>
                    <Item 
                    disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                    editorType={'dxNumberBox'} 
                    dataField={'size_width'} 
                    editorOptions={{
                        placeholder:'W',
                        stylingMode: 'outlined',
                        height: '30px',
                        width: '50px',
                    }}>
                        <RequiredRule message="width is required"/>
                        <Label text="W" location={'right'}/>
                    </Item>
                    <Item 
                        disabled={(data?.status ==='awaiting-shipment'||data?.status ==='on-hold')?false:true}
                        editorType={'dxNumberBox'} 
                        dataField={'size_height'} 
                        editorOptions={{
                            placeholder:'H',
                            stylingMode: 'outlined',
                            height: '30px',
                            width: '50px'
                        }}>
                        <RequiredRule message="height is required"/>
                        <Label text="H" location={'right'}/>
                    </Item>
                    <Item
                        editorType={'dxDateBox'}
                        dataField="warehouseReceiveTimes"
                        colSpan={5}
                        visible={role === 'ROLE_ADMIN'?true:false} 
                        editorOptions={{
                            useMaskBehavior: true,
                            type: "datetime",
                            displayFormat: "shortdate",
                            value:now,
                            min:now,
                            height: '40px',
                            placeholder: '',
                    }}>
                        <Label text={'Receive Time'}/>
                        <RequiredRule message="shipping date is required"/>
                    </Item>
                    <Item 
                        editorType={'dxNumberBox'} 
                        colSpan={5}
                        dataField={'cost'}
                        helpText={'Cost will be determine after we verified the weight and size'}
                        disabled={role === 'ROLE_ADMIN'?false:true} 
                        editorOptions={{
                            format:"$ #,##0.##;($ #,##0.##)",
                            height: '30px',
                            width: '50px',
                            defaultValue:0
                        }}>
                    </Item>
                    <Item 
                        colSpan={5}
                        editorType={'dxTextBox'}
                        visible={role === 'ROLE_ADMIN'?true:false} 
                        dataField={'notes'} 
                        editorOptions={{
                           
                        }}>
                    </Item>
                    <ButtonItem horizontalAlignment="left" colSpan={5}
                            //This button help to preventdefault
                        buttonOptions={{  
                            text: 'shadowButton',
                            type: 'success',
                            useSubmitBehavior: true,
                            visible:false
                        }}
                    />
                    <ButtonItem colSpan={5}>
                        <ButtonOptions
                            type={'default'}
                            useSubmitBehavior={true}
                            text={'Print Packing Slip'}
                            disabled={disabledPrintButton()?true:loading}
                            width={170}
                            >
                              <span className="dx-button-text">
                                {
                                    loading
                                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                                    : role === 'ROLE_ADMIN'?'Print Label':'Print Packing Slip'
                                }
                            </span>
                        </ButtonOptions>
                    </ButtonItem>
                </Form>
                </form>
                <div className={'msg'}>{message}</div>
            </div>
        </React.Fragment>
    );
}

export default AccShipping;